import { Expose } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional } from "class-validator";

export class DefaultInvoiceSendSettings {
  @IsBoolean()
  @Expose()
  isEnabled!: boolean;
  @IsNumber()
  @Expose()
  mailConfigurationId!: number;
  @IsNumber()
  @Expose()
  acesTypeToDocument!: number;
  @IsOptional()
  @IsNumber()
  @Expose()
  dictionaryItemIdXmlGenerator!: number;
}
